module.exports = __webpack_public_path__ + "img/calenderIcon.2ea961e3.svg";